import { observable } from "mobx";
import { Type } from "class-transformer";
import OutgoingBankTransactionDetailResponse from "./outgoingBankTransactionDetailResponse";
import RefundChargeResponse from "./refundChargeResponse";
import OutgoingTransferOriginalPaymentResponse from "./outgoingTransferOriginalPaymentResponse";

// This entity has been generated, do not change its content, your changes might get lost. You CAN modify the rest of the file.
export default class OutgoingTransferPaymentDetailsResponse {
  @observable
  @Type(() => OutgoingTransferOriginalPaymentResponse)
  originalPayment?: OutgoingTransferOriginalPaymentResponse;

  @observable
  @Type(() => OutgoingBankTransactionDetailResponse)
  outgoingPayment!: OutgoingBankTransactionDetailResponse;

  @observable
  @Type(() => RefundChargeResponse)
  refundCharge?: RefundChargeResponse;
}
